import React from 'react';
import PropTypes from 'prop-types';
import InputPolicy from '../InputPolicy/index';

const Input = ({
  onChange,
  label,
  name,
  placeholder,
  value,
  type,
  autoComplete,
  autoFocus,
  required,
  textError,
  icon,
  onFocus,
  onBlur,
  inputPolicy
}) => {
  const hasError = textError.length > 0;
  return (
    <div className="form-group">
      <div className="required">
        <label htmlFor="#">{label}</label>
        {icon && (
          <div className="signup-form--input-icon-container">
            <span className={`signup-form--input-icon ${icon}`} />
          </div>
        )}
        <input
          className={`form-control signup-form--input-field ${hasError ? 'has-error' : ''}`}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          type={type}
          placeholder={placeholder}
          name={name}
          onChange={onChange}
          value={value}
          required={required}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      </div>
      <span className="text-error-utils">{textError}</span>
      <div
        className={`form-signup--input-policy-container ${
          inputPolicy.length > 0 ? 'showing' : 'hiding'
        }`}
      >
        {inputPolicy.length > 0 && <InputPolicy rules={inputPolicy} value={value} label={label} />}
      </div>
      <style>{`
        @media (max-width: 991px) {
          div.form-group {
            padding-top: 0px !important;
            padding-bottom: 0px !important;
          }
        }
        .signup-form--input-icon-container {
          position: absolute;
          height: 46px;
        }
        .signup-form--input-icon {
          line-height: 54px;
          margin-left: 16px;
          color: #9B9B9B;
        }
        .signup-form--input-field {
          text-indent: 32px;
        }
        .form-signup--input-policy-container {
          height: 0;
          opacity: 0;
          transition-property: height, opacity, margin-top;
          transition-duration: .8s, .3s, .8s;
          transition-delay: 0s, .4s, 0s;
        }
        .form-signup--input-policy-container.hiding {
          margin-top: 0px;
        }
        .form-signup--input-policy-container.showing {
          margin-top: 32px;
          height: 140px;
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  required: PropTypes.bool,
  textError: PropTypes.string,
  icon: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  inputPolicy: PropTypes.array
};

Input.defaultProps = {
  textError: '',
  inputPolicy: []
};

export default Input;



// WEBPACK FOOTER //
// ./src/modules/signupForm/ab-show-password-policy/components/Input/Input.js